import React, { Component } from 'react'
import { getParameterByName, getCurrentUser } from './util'
import AuthStep from './AuthStep'
import logo from './logo.png'

class Auth extends Component {
  constructor (props) {
    super()
    this.handleLogin = this.handleLogin.bind(this)
    this.handleGoogleLogin = this.handleGoogleLogin.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.state = {
      email: '',
      password: ''
    }
  }

  UNSAFE_componentWillMount () {
    if (getCurrentUser()) {
      this.props.history.push('/dashboard')
      return
    }
    var code = getParameterByName('code')
    const { origin } = window.location
    if (code) {
      this.props.actions.getSessionRequest({
        code,
        redirectUrl: `${origin}/callback`
      })
    }
  }

  UNSAFE_componentWillReceiveProps ({ isLoggedIn }) {
    if (isLoggedIn) {
      this.props.history.push('/dashboard')
    }
  }

  handleLogin () {
    const { origin } = window.location
    this.props.actions.loginRequest(`${origin}/callback`)
  }

  handleGoogleLogin () {
    const { origin } = window.location
    this.props.actions.googleLoginRequest(`${origin}/callback`)
  }

  handleEmailChange (value) {
    this.setState({ email: value })
  }

  handlePasswordChange (value) {
    this.setState({ password: value })
  }

  render () {
    const { isLoading, errorMessage } = this.props
    return (
      <AuthStep
        isInvalid={false}
        isLoading={isLoading}
        onErrorClick={this.hideError}
        errorMessage={errorMessage}
        title=''
      >
        <div>
          <img src={logo} alt='app-name' className="auth-logo" />
        </div>

        <h2 className='auth-header'>Survey QA</h2>
        <button className="axiom-button-button sf-button" onClick={this.handleLogin}>
          Log In
        </button>
      </AuthStep>
    )
  }
}

Auth.defaultProps = {
  errorMessage: '',
  isInvalid: false,
  isLoading: false
}

export default Auth
